import classNames from '@ui-components-3/ui/lib/utils/classNames'

type SectionHeaderProps = {
  title: string
  onEdit: () => void
  hasIncomplete?: boolean
}

const SectionHeader = ({ title, onEdit, hasIncomplete }: SectionHeaderProps) => {
  return (
    <div
      className={classNames(
        'flex items-center justify-between mb-4',
        hasIncomplete ? 'text-fuchsia-800' : 'text-[unset]',
      )}
    >
      <h5
        className={classNames(
          'typography-body-xxl mr-4 capitalize tracking-[0.18px]',
          hasIncomplete ? 'text-inherit' : 'text-primary-800',
        )}
      >
        {title}
      </h5>
      <button
        type="button"
        className={classNames('btn-small uppercase', hasIncomplete ? 'btn-secondary' : 'btn-secondary-outlined')}
        onClick={onEdit}
      >
        Edit {title}
      </button>
    </div>
  )
}

export default SectionHeader
